import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { KFooterModule } from 'ng-k-footer';
import { KButtonModule } from 'ng-k-button';
import { KHeaderModule } from 'ng-k-header';
import { KIconModule } from 'ng-k-icon';
import { KModalModule } from 'ng-k-modal';
import { PopupModule } from '@progress/kendo-angular-popup';
import { AppRoutingModule } from '../app/app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WizardModule } from './pages/wizard/wizard.module';
import { ClaimsDashboardModule } from './pages/common/claims-dashboard/claims-dashboard.module';
import { OAuthModule, OAuthService, OAuthStorage, ValidationHandler } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks'
import { KUtilsModule } from 'ng-k-utils';
import { ErrorHandler, APP_INITIALIZER, } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpReqInterceptor } from './interceptors/http-req.interceptor';
import { HandleTokenExpireInterceptor } from './interceptors/handle-token-expire.interceptor';
import { environment } from 'src/environments/environment';
import { ClaimDetailModule } from './pages/common/claim-detail/claim-detail.module';
import { CommonModule } from '@angular/common';
import { LoadingInterceptor } from 'ng-k-loading';
import { GlobalLoadingModule } from './pages/global-loading/global-loading.module';
import { OutlineExposureToDustModule } from './pages/asbestosis/exposure/outline-exposure-to-dust/outline-exposure-to-dust.module';
import { EstablishBreachOfDutyModule } from './pages/asbestosis/investigation/establish-breach-of-duty/establish-breach-of-duty.module';
import { EstablishCausationModule } from './pages/asbestosis/investigation/establish-causation/establish-causation.module';
import { ActivityListingModule } from './pages/asbestosis/exposure/activity-listing/activity-listing.module';
import { RadiologicalProgressionAsbestosisModule } from './pages/asbestosis/radiological-progression-asbestosis/radiological-progression-asbestosis.module';
import { NihlModule } from './pages/nihl/nihl.module';
import { PageNotFoundComponent } from './pages/common/page-not-found/page-not-found.component';
import { NihlAnalyseGuard } from './guards/nihl-analyse.guard';
import { ConfirmationModalComponent } from './pages/common/confirmation-modal/confirmation-modal.component';
import { authModuleConfig } from 'src/config/authmodule.config';
import { appConfig } from 'src/config/app.config';
import { UserIdleModule } from 'angular-user-idle';
import { MesotheliomaModule } from './pages/mesothelioma/mesothelioma.module';
import { TimeoutComponent } from './shared/timeout/timeout.component';
import { PleuralthickeningModule } from './pages/pleural-thickening/pleural-thickening.module';
import { CarcinomaofthelungModule } from './pages/carcinoma-of-the-lung/carcinoma-of-the-lung.module';
import { PasswordUpdateModule } from './shared/password-update/password-update.module';
import { RadiologicalProgressionChartAsbestosisModule } from './pages/asbestosis/radiological-progression-chart/radiological-progression-chart-asbestosis.module';
import { ClaimsInsightsModule } from './pages/common/claims-insights/claims-insights.module';


@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    ConfirmationModalComponent,
    TimeoutComponent,
  ],
  imports: [
    BrowserModule,
    KFooterModule,
    KButtonModule,
    KHeaderModule,
    KModalModule,
    KIconModule,
    WizardModule,
    ClaimsDashboardModule,
    PopupModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    OAuthModule.forRoot(authModuleConfig),
    KUtilsModule,
    CommonModule,
    GlobalLoadingModule,
    ClaimDetailModule,
    OutlineExposureToDustModule,
    EstablishBreachOfDutyModule,
    EstablishCausationModule,
    ActivityListingModule,
    NihlModule,
    UserIdleModule.forRoot({ idle: appConfig.userIdle, timeout: appConfig.userIdleTimeOut, ping: appConfig.userIdlePing }),
    MesotheliomaModule,
    PleuralthickeningModule,
    CarcinomaofthelungModule,
    PasswordUpdateModule,
    RadiologicalProgressionAsbestosisModule,
    RadiologicalProgressionChartAsbestosisModule,
    ClaimsInsightsModule
  ],
  exports: [
    GlobalLoadingModule
  ],
  providers: [
    { provide: ValidationHandler, useClass: JwksValidationHandler },
    OAuthService,
    { provide: OAuthStorage, useValue: sessionStorage },
    { provide: 'armApiEndpoint', useValue: getArmAPIEndPoint() },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpReqInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HandleTokenExpireInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    NihlAnalyseGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private oauthService: OAuthService) {
  }

}

export function getConfEndpoint(): string {
  return environment.kcg_config
}

export function getArmAPIEndPoint(): string {
  return environment.KcgApiUrl
}